import { AttributeValueType, AttributeSelectionsByAttributeId } from "@sourceful/shared-types";

export const getSelectedAttributeValues = (
  attributeSelection: AttributeSelectionsByAttributeId,
  attributeId: string
): AttributeValueType[] => {
  const optionSelection = attributeSelection[attributeId];
  if (!optionSelection) {
    return [];
  }

  return Array.isArray(optionSelection?.value)
    ? optionSelection?.value // checkbox
    : optionSelection?.value
    ? [optionSelection.value]
    : []; // radio
};
